import { render, staticRenderFns } from "./RotatedLabels.vue?vue&type=template&id=00f375ce"
import script from "./RotatedLabels.vue?vue&type=script&lang=js"
export * from "./RotatedLabels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports